import {
  getSeoReportCategory,
  getSeoReportSubcategory,
} from '@dupe/common/research-report'

// Router-agnostic label helpers shared by the App Router /reports list pages
// (server metadata + client UI). Previously duplicated inline across the three
// pages-router list pages.
function humanizeCategorySlug(slug: string): string {
  return slug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

export function getReportCategoryLabel(slug: string): string {
  return getSeoReportCategory(slug)?.label ?? humanizeCategorySlug(slug)
}

export function getReportSubcategoryLabel(
  categorySlug: string,
  subcategorySlug: string
): string {
  return (
    getSeoReportSubcategory(categorySlug, subcategorySlug)?.label ??
    humanizeCategorySlug(subcategorySlug)
  )
}
